import { ASSET_VERSION_QUERY } from '../../../utils/assetVersionQuery';
// XXX CSS is used on Web, JavaScript styles are use only for mobile. Export an
// (empty) object so that styles[*] statements on Web don't trigger errors.
export default {};
export const DROPBOX_LOGO = `images/dropboxLogo_square.png${ASSET_VERSION_QUERY}`;
export const LOCAL_RECORDING = `images/downloadLocalRecording.png${ASSET_VERSION_QUERY}`;
export const ICON_CLOUD = `images/icon-cloud.png${ASSET_VERSION_QUERY}`;
export const JITSI_LOGO = `images/jitsiLogo_square.png${ASSET_VERSION_QUERY}`;
export const ICON_INFO = 'images/icon-info.png';
export const ICON_USERS = 'images/icon-users.png';
export const ICON_OPTIONS = 'images/icon-info.png';
